import api from "api/axios";

export const getProducts = (params) =>
  api.get("/products", params);

export const getProductById = (id) =>
  api.get(`/products/${id}`);

export const getProductByCompany = async (id , params = {}) =>{
   const response =  await api.get(`/products/company/${id}`,{
    params,
    signal: params.signal, // Pass AbortController signal if provided
  });
   return response.data;
}
  

export const createProduct = (payload) =>
  api.post("/products/", payload);

export const updateProduct = (id, payload) =>
  api.put(`/products/${id}`, payload);

export const deleteProduct = (id, payload) =>
  api.delete(`/products/${id}`, { data: payload });

export const getProductByExhibitor = (id) =>
  api.get(`/products/exhibitor/${id}`);
